import { LocalStorage } from '@/modules/core/app/helpers/LocalStorage';
import { SpotlightGroup, SpotlightItem } from '@/modules/spotlight/models/SpotlightGroup';
import { SpotlightGroupCollection } from '@/modules/spotlight/models/SpotlightGroupCollection';
import { SpotlightCache } from '@/modules/spotlight/constants/SpotlightCache';

export class SpotlightRecentlyViewedCache extends LocalStorage {
  private maxSize: number = 25;

  addItem(item: SpotlightItem): void {
    const collection: SpotlightGroupCollection = this.getItems();

    if (collection.total >= this.maxSize) {
      collection.shiftItemFromGroup(item);
    }

    if (!collection.hasItems || !collection.hasItemInGroup(item)) {
      collection.addItemToGroup(item);
    }

    super.setItem(SpotlightCache.RECENTLY_VIEWED, JSON.stringify(collection.items));
  }

  getItems(): SpotlightGroupCollection {
    const data: SpotlightGroup[] | undefined = JSON.parse(
      super.getItem(SpotlightCache.RECENTLY_VIEWED)
    );

    return data
      ? SpotlightGroupCollection.mapModel(data)
      : SpotlightGroupCollection.getEmptyCollection();
  }
}

export default new SpotlightRecentlyViewedCache();
